import React, { useState, useEffect } from 'react'

const MONTHS = [
  { label: 'Janeiro', value: 1 },
  { label: 'Fevereiro', value: 2 },
  { label: 'Março', value: 3 },
  { label: 'Abril', value: 4 },
  { label: 'Maio', value: 5 },
  { label: 'Junho', value: 6 },
  { label: 'Julho', value: 7 },
  { label: 'Agosto', value: 8 },
  { label: 'Setembro', value: 9 },
  { label: 'Outubro', value: 10 },
  { label: 'Novembro', value: 11 },
  { label: 'Dezembro', value: 12 }
]

function parseDateValue(dateValue) {
  if (!dateValue) return { month: '', year: '' }
  const date = new Date(dateValue)
  if (isNaN(date.getTime())) return { month: '', year: '' }
  return {
    month: date.getMonth() + 1,
    year: date.getFullYear()
  }
}

function formatDateValue(month, year) {
  if (!month || !year) return ''
  return `${year}-${String(month).padStart(2, '0')}-01`
}

export default function DateSelectField({
  label,
  name,
  defaultValue,
  value,
  onChange,
  error,
  className = '',
  startYear = new Date().getFullYear() - 2,
  endYear = new Date().getFullYear() + 5
}) {
  const isControlled = value !== undefined
  const initialParsed = parseDateValue(isControlled ? value : defaultValue)

  const [month, setMonth] = useState(initialParsed.month)
  const [year, setYear] = useState(initialParsed.year)

  // Sync with controlled value
  useEffect(() => {
    if (isControlled) {
      const parsed = parseDateValue(value)
      setMonth(parsed.month)
      setYear(parsed.year)
    }
  }, [value, isControlled])

  const handleMonthChange = (e) => {
    const newMonth = e.target.value ? parseInt(e.target.value) : ''
    setMonth(newMonth)
    if (onChange && isControlled) {
      onChange({ target: { value: formatDateValue(newMonth, year) } })
    }
  }

  const handleYearChange = (e) => {
    const newYear = e.target.value ? parseInt(e.target.value) : ''
    setYear(newYear)
    if (onChange && isControlled) {
      onChange({ target: { value: formatDateValue(month, newYear) } })
    }
  }

  // Generate year options
  const years = []
  for (let y = startYear; y <= endYear; y++) {
    years.push(y)
  }

  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <div className="flex gap-2">
        <select
          name={`${name}(2i)`}
          value={month}
          onChange={handleMonthChange}
          className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:ring-brand-light focus:border-brand-light bg-white"
        >
          <option value="">Selecione o mês</option>
          {MONTHS.map(({ label: monthLabel, value: monthValue }) => (
            <option key={monthValue} value={monthValue}>
              {monthLabel}
            </option>
          ))}
        </select>
        <select
          name={`${name}(1i)`}
          value={year}
          onChange={handleYearChange}
          className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:ring-brand-light focus:border-brand-light bg-white"
        >
          <option value="">Selecione o ano</option>
          {years.map(y => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
        {/* Hidden day field - Rails date_select requires all three parts */}
        <input type="hidden" name={`${name}(3i)`} value="1" />
      </div>
      {error && (
        <div className="mt-1 text-red-600 text-sm">{error}</div>
      )}
    </div>
  )
}
